import React from 'react'

function AlertBanner() {
  return (
<>
    <p>Due to Heroku limitations 😞, Ruby on Rails project demos are not included</p>
    <p>Find the codebases on my <a href="https://github.com/theBwoyProgrammer?tab=repositories&q=&type=&language=ruby" className='gitlink' target="_blank" rel="noopener noreferrer">GitHub</a></p>
</>
  )
}

export default AlertBanner